import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-logout-dialog',
  templateUrl: './logout-dialog.component.html',
  styleUrls: ['./logout-dialog.component.scss']
})
export class LogoutDialogComponent implements OnInit {
  userName: string = 'Nitesh Chandel';
  userEmail: string = 'nicc@yopmail.com';
  userInitials: string = 'NC';

  constructor(
    public dialogRef: MatDialogRef<LogoutDialogComponent>,
    private router: Router
  ) {}

  ngOnInit(): void {
    let user: any = null;
    try {
      const userStr = localStorage.getItem('user');
      if (userStr) {
        user = JSON.parse(userStr);
      }
    } catch (e) {}

    const firstName = user?.firstName || user?.name?.split(' ')[0] || localStorage.getItem('firstName') || '';
    const lastName = user?.lastName || user?.name?.split(' ')[1] || localStorage.getItem('lastName') || '';
    let name = (firstName + ' ' + lastName).trim();
    if (!name) {
      name = user?.name || localStorage.getItem('name') || 'Nitesh Chandel';
    }
    this.userName = name;

    let email = user?.email || localStorage.getItem('email') || localStorage.getItem('loginEmail') || '';
    if (!email) {
      email = 'nicc@yopmail.com';
    }
    this.userEmail = email;

    const parts = this.userName.split(' ').filter(p => p.length > 0);
    if (parts.length >= 2) {
      this.userInitials = (parts[0][0] + parts[1][0]).toUpperCase();
    } else if (parts.length === 1 && parts[0].length > 0) {
      this.userInitials = parts[0].substring(0, 2).toUpperCase();
    } else {
      this.userInitials = 'NC';
    }
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirmLogout(): void {
    this.dialogRef.close(true);
    localStorage.clear();
    this.router.navigate(['/auth/login']);
  }
}

